import pluralize from 'pluralize'

export const RISK_QUESTIONNAIRE_THREAD_LABELS = {
  TITLE: 'Smart evidence request',
  SHARED_PREFIX: 'Shared',
  MARK_AS_RESOLVED: 'Mark as resolved',
  MARK_AS_RESOLVED_TOOLTIP: "Moves this control to the recipient's Resolved tab.",
  VALIDATED_TOOLTIP:
    'Validated controls are resolved automatically. Change the validation status to Gap or No evidence to un-resolve.',
  AWAITING_REVIEW_TITLE: 'Ready for review',
  AWAITING_REVIEW_DESCRIPTION:
    'Review the vendor’s response and mark the control as “Validated” if the evidence is sufficient.',
  AWAITING_RECIPIENT_TITLE: "Awaiting the recipient's response.",
  AWAITING_RECIPIENT_DESCRIPTION: 'Nothing to review yet.',
  AWAITING_REOPEN_TITLE: 'Awaiting reopen',
  AWAITING_REOPEN_DESCRIPTION:
    'The request is still locked. Reopen it so the recipient can respond.',
  RESOLVED_TITLE: 'Resolved',
  RESOLVED_DESCRIPTION: "moved to the Resolved tab in the recipient's evidence request.",
  MARKED_AS_RESOLVED_ACTIVITY: 'Marked as resolved',
  UNMARKED_AS_RESOLVED_ACTIVITY: 'Remove marked as resolved',
  ADD_COMMENT_PLACEHOLDER: 'Add a comment',
  LEMA_AI_VERDICT: "Lema AI's verdict",
  EVIDENCE: 'Evidence',
  EVALUATIONS_SUMMARY: (evaluations: number, statusChanges: number) =>
    statusChanges === 0
      ? `Evaluated ${pluralize('time', evaluations, true)}`
      : `Evaluated ${pluralize('time', evaluations, true)} · Status changed ${pluralize('time', statusChanges, true)}`,
  SHOW_EARLIER_EVALUATIONS: (count: number) =>
    `Show ${pluralize('earlier evaluation', count, true)}`,
  HIDE_EARLIER_EVALUATIONS: 'Hide earlier evaluations',
  EARLIER_EVALUATION_EVIDENCE: (artifactNames: string[]) => `Evidence: ${artifactNames.join(', ')}`,
} as const

export const CONTROL_LABELS = {
  evaluateControl: 'Evaluate control',
  evaluating: 'Evaluating...',
  emptyNotEvaluated: {
    title: 'Not yet evaluated',
    subtitle: 'This control will be evaluated automatically once the assessment starts.',
  },
  seeActivityLog: 'See activity log',
  vendorReplied: (comments: number) => `Vendor replied — ${pluralize('comment', comments, true)}`,
  suggestedActions: 'Suggested actions',
  signals: 'Signals',
  aiVerdict: "Lema AI's verdict",
} as const

export const CONTROL_EVALUATION_ALERT_LABELS = {
  lastEvaluatedByLema: (dateStr: string) => `Last evaluated by Lema: ${dateStr}.`,
  calculatedDuringPastAssessment: (assessmentName: string) =>
    `This control was calculated during a past ${assessmentName} assessment.`,
  calculatedDuringAssessmentWithDate: (dateStr: string, assessmentName: string) =>
    `This control was calculated during on ${dateStr} as part of the ${assessmentName} assessment`,
  calculatedDuringDate: (dateStr: string) => `This control was calculated during on ${dateStr}`,
  newInputsIdentified:
    'New inputs have been identified. Reassess this vendor to re-evaluate the control.',
} as const
